
var React = require("react");
var ActionButton = require("../generic/ActionButton.jsx");
var DataActionUtil = require("../../../util/DataActionUtil.js");

class ExportLBRButton extends React.Component  {
    constructor(){
        super()
    }

    render(){
       if(~this.props.version){
           return <ActionButton 
                       {...this.props}
                       text="Export LBR"
                       mainClass="blue"
                       action={DataActionUtil.exportAsset}
                  />
       }
        
       return null
    }
}

module.exports = ExportLBRButton;